module.exports = "<div class=\"self-service-list hide\"> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/js/app/pages/q&a/selfService/indexTpl.html
// module id = 253
// module chunks = 0